import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Float, Sphere, Box, Cylinder, Torus, Environment } from '@react-three/drei';

const CMYKScene = () => {
  const groupRef = useRef();

  useFrame((state) => {
    if (groupRef.current) {
      groupRef.current.rotation.y = state.clock.getElapsedTime() * 0.1;
    }
  });

  return (
    <>
      {/* Premium lighting setup */}
      <ambientLight intensity={0.6} />
      <directionalLight position={[10, 10, 5]} intensity={1.5} color="#ffffff" />
      <pointLight position={[-10, -10, -5]} intensity={1} color="#00AEEF" />
      <pointLight position={[10, -5, 5]} intensity={1} color="#EC008C" />
      <pointLight position={[0, 10, -5]} intensity={0.8} color="#FFF200" />
      <Environment preset="city" />

      <group ref={groupRef}>
        {/* CYAN Sphere - Top Left */}
        <Float speed={2} rotationIntensity={0.5} floatIntensity={1.5}>
          <Sphere args={[1, 64, 64]} position={[-3.5, 2, 0]}>
            <meshPhysicalMaterial
              color="#00AEEF"
              roughness={0.1}
              metalness={0.3}
              clearcoat={1}
              clearcoatRoughness={0.1}
              emissive="#00AEEF"
              emissiveIntensity={0.15}
            />
          </Sphere>
        </Float>

        {/* MAGENTA Box - Right */}
        <Float speed={1.5} rotationIntensity={0.8} floatIntensity={1.5}>
          <Box args={[1.5, 1.5, 1.5]} position={[3.5, -0.5, -1]}>
            <meshPhysicalMaterial
              color="#EC008C"
              roughness={0.1}
              metalness={0.4}
              clearcoat={1}
              clearcoatRoughness={0.1}
              emissive="#EC008C"
              emissiveIntensity={0.15}
            />
          </Box>
        </Float>

        {/* YELLOW Cylinder - Front Center */}
        <Float speed={1.8} rotationIntensity={0.6} floatIntensity={1.2}>
          <Cylinder args={[0.7, 0.7, 1.8, 32]} position={[0, 0.5, 2.5]} rotation={[0.5, 0, 0.5]}>
            <meshPhysicalMaterial
              color="#FFF200"
              roughness={0.15}
              metalness={0.3}
              clearcoat={1}
              clearcoatRoughness={0.1}
              emissive="#FFF200"
              emissiveIntensity={0.2}
            />
          </Cylinder>
        </Float>

        {/* BLACK/KEY Torus - Top Right */}
        <Float speed={2.2} rotationIntensity={0.4} floatIntensity={0.8}>
          <Torus args={[0.7, 0.25, 16, 100]} position={[2.5, 3, 1]} rotation={[0.5, 0.5, 0]}>
            <meshPhysicalMaterial
              color="#111111"
              roughness={0.1}
              metalness={0.9}
              clearcoat={1}
              clearcoatRoughness={0.05}
            />
          </Torus>
        </Float>

        {/* CYAN small sphere - Bottom Left */}
        <Float speed={1.6} rotationIntensity={0.7} floatIntensity={1.3}>
          <Sphere args={[0.6, 32, 32]} position={[-2.5, -2.5, -2]}>
            <meshPhysicalMaterial
              color="#00AEEF"
              roughness={0.1}
              metalness={0.4}
              clearcoat={1}
              emissive="#00AEEF"
              emissiveIntensity={0.2}
            />
          </Sphere>
        </Float>

        {/* MAGENTA small box - Far Back */}
        <Float speed={1.4} rotationIntensity={0.9} floatIntensity={1}>
          <Box args={[0.8, 0.8, 0.8]} position={[-1.5, -1.5, -3]}>
            <meshPhysicalMaterial
              color="#EC008C"
              roughness={0.1}
              metalness={0.4}
              clearcoat={1}
              emissive="#EC008C"
              emissiveIntensity={0.25}
            />
          </Box>
        </Float>

        {/* YELLOW small sphere */}
        <Float speed={2.5} rotationIntensity={0.5} floatIntensity={1.4}>
          <Sphere args={[0.4, 32, 32]} position={[1.5, 2.5, -2]}>
            <meshPhysicalMaterial
              color="#FFF200"
              roughness={0.15}
              metalness={0.3}
              clearcoat={1}
              emissive="#FFF200"
              emissiveIntensity={0.3}
            />
          </Sphere>
        </Float>
      </group>
    </>
  );
};

export default CMYKScene;
